import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import sellerDiscountSettingService from 'services/seller/discountSetting';

const initialState = {
  loading: false,
  discountSettings: [],
  error: '',
  params: {
    page: 1,
    perPage: 10,
  },
  meta: {},
};

export const fetchSellerDiscountSettings = createAsyncThunk(
  'sellerDiscountSetting/fetchSellerDiscountSettings',
  (params = {}) => {
    return sellerDiscountSettingService
      .getAll({ ...initialState.params, ...params })
      .then((res) => res);
  },
);

const sellerDiscountSettingSlice = createSlice({
  name: 'sellerDiscountSetting',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSellerDiscountSettings.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchSellerDiscountSettings.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.discountSettings = payload.data;
      state.meta = payload.meta;
      state.params.page = payload.meta.current_page;
      state.params.perPage = payload.meta.per_page;
      state.error = '';
    });
    builder.addCase(fetchSellerDiscountSettings.rejected, (state, action) => {
      state.loading = false;
      state.discountSettings = [];
      state.error = action.error.message;
    });
  },
});

export default sellerDiscountSettingSlice.reducer;